import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Logo from '../brand/Logo';

interface LoadingScreenProps {
  /** fill the viewport (route loading) or just its container (section loading) */
  fullscreen?: boolean;
  label?: string;
}

/** Brand loader: the logo breathes, three dots ripple beneath it. */
const LoadingScreen: React.FC<LoadingScreenProps> = ({ fullscreen = false, label }) => {
  const { t } = useTranslation();
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2.5,
        minHeight: fullscreen ? '70vh' : 240, width: '100%',
      }}
    >
      <motion.div animate={{ scale: [1, 1.05, 1], opacity: [0.85, 1, 0.85] }} transition={{ duration: 1.6, repeat: Infinity, ease: 'easeInOut' }}>
        <Logo height={44} />
      </motion.div>
      <Box sx={{ display: 'flex', gap: 1 }}>
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            animate={{ y: [0, -8, 0] }}
            transition={{ duration: 0.9, repeat: Infinity, delay: i * 0.15, ease: 'easeInOut' }}
            style={{ width: 9, height: 9, borderRadius: 9, background: ['#ADA2FF', '#ADD4FF', '#015287'][i], display: 'block' }}
          />
        ))}
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ letterSpacing: '0.1em' }}>
        {label || t('common.loading')}…
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
